"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doDebounce = exports.debounce = exports.isArrayOrObject = void 0;
var isArrayOrObject = function (value) {
    return Array.isArray(value) || typeof value === 'object';
};
exports.isArrayOrObject = isArrayOrObject;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function debounce(func, wait) {
    var timeout;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var context = this;
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(function () {
            timeout = null;
            func.apply(context, args);
        }, wait);
    };
}
exports.debounce = debounce;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function doDebounce(func, wait) {
    var timeout;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var context = this;
        if (!timeout) {
            func.apply(context, args);
            timeout = setTimeout(function () {
                timeout = null;
            }, wait);
        }
    };
}
exports.doDebounce = doDebounce;
